import React from "react";
import "../../App.css";

class ParameterMismatchResourceFooter extends React.Component {
  render() {
    return (
        <i>
        <h4> More information on this</h4>
        <div className="Indent-1">
          <a href="https://forum.processing.org/two/discussion/3541/how-to-fix-error-the-method-in-the-type-is-not-applicable-for-the-arguments#Comment_11663:~:text=Arguments%20are%20the%20%22things%22%20you%20%22pass%22%20into%20a%20function." target="_blank" rel="noopener noreferrer">
            Processing Forum
          </a>
        </div>
      </i>
    );
  }
}

export default ParameterMismatchResourceFooter;
